module.exports = __webpack_public_path__ + "static/media/finished-img2.0c6150aa.png";